module.exports = __webpack_public_path__ + "static/img/Roboto-RegularItalic.39c358e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/roboto-fontface/fonts/roboto/Roboto-RegularItalic.svg
// module id = mkgR
// module chunks = 3